import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from './loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent {
	show$: Observable<boolean>;

	constructor(private loaderService: LoaderService) {
		this.show$ = this.loaderService.isLoading;
	}
}
